import { render, staticRenderFns } from "./show-calculate-result.vue?vue&type=template&id=07867c7d&"
import script from "./show-calculate-result.vue?vue&type=script&lang=js&"
export * from "./show-calculate-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports